import { connect } from 'react-redux';
import CreateContract from './CreateContract';

import { createContract } from '../../actions/insuranceContracts';
import { getSubmitStatus } from 'reducers';
import { attSubPage } from 'decorators/subPage';

const mapStateToProps = (state) => ({
  saveStatus: getSubmitStatus(state, 'insuranceContract'),
  carrier: 'att',
});

const mapDispatchToProps = {
  onSubmit: createContract,
};

export default attSubPage(
  connect(mapStateToProps, mapDispatchToProps)(CreateContract),
);
